import React, { useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'

import { labelCodeIdVar } from 'modulesCommon/store'
import { ProjectCreation } from 'modules/ProjectCreate/components'
import { formatToOptionsById } from 'shared/utils/labels'
import { useZonesList } from 'modulesCommon/serviceHooks'

const ProjectStep = () => {
  const zoneId = useReactiveVar(labelCodeIdVar)
  const { getUnitsByZoneId } = useZonesList()
  const unitsOptions = useMemo(() => getUnitsByZoneId(zoneId).map(formatToOptionsById), [getUnitsByZoneId, zoneId])

  return <ProjectCreation unitsOptions={unitsOptions} />
}

export default ProjectStep
